<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>
    <navbar>
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light">DEVICE</span>
        <span class="font-weight-medium">LIST</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <!--m-menubutton
        icon="mdi-close-circle"
        @click="$router.go(-1)"
      >Cancel</m-menubutton>
      <v-spacer></v-spacer-->
    </navbar>
    <v-content class="secondary--text text--darken-2">
      <v-container fluid fill-height align-content-start>
        <v-flex full-width>
        <resource-view
          :validation-rules="validationRules"
          :update-endpoint="apiEndpoints.deviceAdminUpdate"
          :index-endpoint="apiEndpoints.deviceAdmin"
          :prepare-model="prepareDeviceModel"
          expandIcon="mdi-cog"
          updateButtonText="Update Device"
        >
          <!-- ********** RESOURCE UPDATE FORM ********** -->
          <template v-slot:update-form="{model}">
            <v-row>
              <v-col>
                  <m-textinput :model="model" name="device_name" label="Device Name" required></m-textinput>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                  <m-textinput :model="model" name="device_token" label="Device Token" required></m-textinput>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                  <m-autocomplete :model="model" name="group_id" model-text-field="group_name" label="Group" :endpoint="apiEndpoints.deviceGroupAutocomplete" required></m-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                  <m-checkbox dense :model="model" name="remote_shell" label="Remote Shell Active"></m-checkbox>
              </v-col>
            </v-row>
          </template>
        </resource-view></v-flex>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import apiRequestMixin from "../mixins/api-request";
import apiEndpointsMixin from "../mixins/api-endpoints";
import formatDateMixin from "../mixins/format-date";

export default {
  mixins: [
    apiRequestMixin,
    apiEndpointsMixin,
    formatDateMixin,
  ],
  data(){
    return {
      validationRules:{
        device_name: model => [
          //v => !!v || "Device name is required",
          v => (!v || v.length >= 3) || "Device name must be at least 3 characters"
        ],
        device_token: model => [
          v => !!v || "Device token is required",
          v => (v && v.length == 16) || "Device token must be exactly 16 characters",
          v => (v && /^[a-f0-9]{16}$/.test(v)) || "Device token must only contain lower case hexadecimal characters (a-f, 0-9)",
        ],
        group_id: model => [
          v => !!v || "You must choose a valid autocompleted value.",
        ],
      },
    };
  },
  methods: {
    showError(message) {
      // errors can occur after the page has been navigated away from.
      if (this.$refs.errorBox) {
        this.$refs.errorBox.showError(message);
      }
    },
    prepareDeviceModel(value, index) {
      value.last_contact = new Date(value.last_contact * 1000);
      value.last_contact = value.last_contact.getFullYear() < 2001 ? "Never been online" : this.fullDateTime(value.last_contact)
      value.online = value.online ? "ONLINE" : "OFFLINE";
      //value.device_name = value.device_name || "Not Set."
    },
  }
};
</script>
